import React, { useContext } from 'react'
import { Box, Typography, Button } from '@mui/material'
import { getCDNURL } from 'network/api/networkSettings'
import { LanguageContext } from 'context/LanguageContext'


const BasketUpdateDialog = ({ onContinue, onKeepPickupTime }) => {
    const { strings } = useContext(LanguageContext)
    const applogo = getCDNURL() + 'assets/images/applogo.png'

    return (
        <Box
            sx={{
                backgroundColor: '#fff',
                borderRadius: '32px',
                padding: '40px 32px',
                textAlign: 'center',
                maxWidth: 600,
                margin: '0 auto'
            }}
        >
            <Box mb={3}>
                <img
                    src={applogo}
                    alt={strings.Logo}
                    style={{ height: 60 }}
                />
            </Box>

            <Typography variant="h4" fontWeight={700} gutterBottom>
                {strings.basketUpdateWarningTitle}
            </Typography>

            <Typography
                variant="body1"
                sx={{ color: 'text.secondary', mb: 4 }}
            >
                {strings.basketUpdateWarningMsg}
            </Typography>

            <Button
                variant="contained"
                fullWidth
                onClick={onContinue}
                sx={{
                    borderRadius: '60px',
                    py: 1.6,
                    fontWeight: 600,
                    textTransform: 'none',
                    fontSize: '1rem',
                    mb: 2,
                    backgroundColor: '#007350',
                    '&:hover': { backgroundColor: '#007350' }
                }}
            >
                {strings.continueLabel}
            </Button>

            <Button
                variant="outlined"
                fullWidth
                onClick={onKeepPickupTime}
                sx={{
                    borderRadius: '60px',
                    py: 1.6,
                    fontWeight: 600,
                    textTransform: 'none',
                    fontSize: '1rem',
                    color: '#007350',
                    borderBlockColor: '#007350',
                    '&:hover': { borderBlockColor: '#007350' }
                }}
            >
                {strings.keepCurrentPickupTime}
            </Button>
        </Box>
    )
}

export default BasketUpdateDialog
